import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';

import { marketting_main_server_ip } from '../../communication_system/communication_ips';
import { buildSinorTripPaymentParams, normalizeSinorTripProduct, SINOR_TRIP_GATHERING_ID } from './sinorTripPayment';

const membershipProductUrl = `${marketting_main_server_ip.replace(/\/$/, '')}/gatheringMembership/product`;

function SinorTripInfoComponent({ setParams }) {
    const [product, setProduct] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;

        axios
            .get(membershipProductUrl, {
                params: { gathering_id: SINOR_TRIP_GATHERING_ID },
            })
            .then((response) => {
                if (!active) return;
                const nextProduct = normalizeSinorTripProduct(response);
                setProduct(nextProduct);
                setError(!nextProduct);
            })
            .catch(() => {
                if (active) setError(true);
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        return () => {
            active = false;
        };
    }, []);

    useEffect(() => {
        if (!product) return;
        setParams((current) => ({
            ...current,
            ...buildSinorTripPaymentParams({ product, startDate }),
        }));
    }, [product, setParams, startDate]);

    if (loading) {
        return <InfoMessage>시놀트립 상품을 불러오는 중입니다.</InfoMessage>;
    }

    if (error || !product) {
        return <ErrorMessage>판매 중인 시놀트립 상품을 불러오지 못했습니다.</ErrorMessage>;
    }

    return (
        <div>
            <ColWrapper>
                <Subtitle>결제상품</Subtitle>
                <SubInfo>{product.title}</SubInfo>
            </ColWrapper>
            <ColWrapper>
                <Subtitle>모임</Subtitle>
                <SubInfo>{product.gatheringName}</SubInfo>
            </ColWrapper>
            <ColWrapper>
                <Subtitle>결제가격</Subtitle>
                <SubInfo>{product.price.toLocaleString('ko-KR')}원</SubInfo>
            </ColWrapper>
            <ColWrapper>
                <Subtitle>멤버십 시작일</Subtitle>
                <SubInfo>
                    <Input
                        aria-label="멤버십 시작일"
                        type="date"
                        value={startDate}
                        onChange={(event) => setStartDate(event.target.value)}
                    />
                </SubInfo>
            </ColWrapper>
        </div>
    );
}

export default SinorTripInfoComponent;

const ColWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 0 1% 2% 1%;
`;

const Subtitle = styled.div`
    width: 85px;
    color: gray;
    font-size: 13px;
`;

const SubInfo = styled.div`
    min-width: 160px;
    font-size: 13.5px;
    font-weight: 500;
`;

const Input = styled.input`
    height: 21px;
    padding: 1px 5px;
    border: 1px solid #cccccc;
    outline: none;
`;

const InfoMessage = styled.div`
    color: gray;
    font-size: 13px;
`;

const ErrorMessage = styled(InfoMessage)`
    color: #d32f2f;
`;
